<!-- Trailer Modal - Place at the very top -->
<div class="trailer-modal-backdrop" *ngIf="showPlayer" (click)="closeTrailer()" [@fadeIn]>
  <div class="trailer-modal-container" (click)="$event.stopPropagation()">
    <!-- Close Button -->
    <button class="trailer-close-btn" (click)="closeTrailer()" aria-label="Close trailer">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
    
    <!-- Trailer Player - simplified, removed nested div -->
    <div class="trailer-content" #TrailerContainer id="trailer-player"></div>
  </div>
</div>

<app-normal-navbar></app-normal-navbar>     
<app-tv-details 
  [trailerDiv]="trailerContainer"
  [(showPlayer)]="showPlayer">
</app-tv-details>

<div class="tv-carousels-wrap">
  <app-tv-credits></app-tv-credits>
  <app-tv-similar></app-tv-similar>
</div>

<section class="flex-parent">
  <div class="tv-left">
    <app-season-status></app-season-status>
    <app-tv-recommendations [(showPlayer)]="showPlayer"></app-tv-recommendations>
  </div>
  <div class="tv-right">
    <app-tv-accounts></app-tv-accounts>
    <app-tv-facts></app-tv-facts>
  </div>
</section>
<app-footer></app-footer>